import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {BaseSupplier} from '../types';

const getSuppliersResponseMock: BaseSupplier[] = [
  {
    id: 'a024ebfe-b790-47b2-ac85-da86ac458869',
    name: 'Hyundai Motor Czech s.r.o.',
  },
  {
    id: 'c5dd0275-2599-42fb-bf9d-f657a30e1e32',
    name: 'Mercedes-Benz Česká republika s.r.o.',
  },
];

const getSuppliersResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v1/supplier', () =>
      HttpResponse.json({supplier: getSuppliersResponseMock})
    )
  );

export const metadaWarehouseSupplierApiMock = {
  getSuppliersResponseMock,
  getSuppliersResponseInterceptor,
};
